import script from "./bviReportIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./bviReportIndex.vue?vue&type=script&lang=ts&setup=true"

import "./bviReportIndex.vue?vue&type=style&index=0&id=4307783d&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4307783d"]])

export default __exports__